import React from 'react';
import { useLocation } from 'react-router-dom';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full-height';
  scrolled?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ className = '', size = 'md', scrolled = false }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20',
    'full-height': 'h-12 w-auto' // Full height with auto width to maintain aspect ratio
  };

  // Determine which logo to use based on navigation state
  const getLogoSrc = () => {
    if (isHomePage) {
      // On home page: use blue logo when scrolled (white background), green logo when not scrolled (transparent background)
      return scrolled ? '/Logo-Blue copy copy copy.png' : '/Logo-Green.png';
    } else {
      // On other pages: use blue logo when scrolled (white background), green logo when not scrolled (transparent background)
      return scrolled ? '/Logo-Green.png' : '/Logo-Green.png';
    }
  };

  return (
    <div className={`${sizeClasses[size]} ${className} transition-all duration-300`}>
      <img
        src={getLogoSrc()}
        alt="OutstandingNet Logo"
        className="w-full h-full object-contain transition-all duration-300"
        width={size === 'full-height' ? 160 : size === 'xl' ? 80 : size === 'lg' ? 64 : size === 'md' ? 48 : 32}
        height={size === 'full-height' ? 48 : size === 'xl' ? 80 : size === 'lg' ? 64 : size === 'md' ? 48 : 32}
      />
    </div>
  );
};